import { zodSchemes } from '@approvalmax/utils';
import { z } from 'zod';

import { messages } from './SchedulePaymentPopup.messages';

export const schema = z.object({
    date: z.date({ required_error: messages.requiredField, message: messages.requiredField }),
    time: zodSchemes.required.textField.string(),
});
